import { formatarData, formatarMoeda } from "../../../utils/solicitacoes/formatters";
import Campo from "../Shared/Campo";
import RateioOrcamentarioTabela from "../Shared/RateioOrcamentarioTabela";
import UltimosLancamentosFortes, { podeConsultarFornecedorNoFortes } from "../Shared/UltimosLancamentosFortes";
import { useAuth } from "../../../context/authContext";

const TIPO_DESPESA_LABEL = {
    SUPRIMENTOS: "Suprimentos",
    CONTAS_A_PAGAR: "Contas a Pagar",
};

// Dados acumulados do processo — sempre visível, independentemente da etapa atual (diferente do
// componente de "Etapa atual", que só mostra o que é acionável naquele momento).
export default function DetalheDespesa({ detalheProcesso }) {
    const { user } = useAuth();
    if (!detalheProcesso) return null;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6">
            <h2 className="font-display text-base font-semibold text-foreground mb-4">Dados da Solicitação</h2>

            {detalheProcesso.motivoPendencia && (
                <div className="mb-4 flex items-start gap-2.5 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2.5">
                    <i className="fa fa-exclamation-triangle text-amber-500 text-sm mt-0.5 shrink-0" />
                    <div className="min-w-0">
                        <span className="block text-[11px] uppercase tracking-wide font-semibold text-amber-700">Motivo da pendência</span>
                        <span className="block text-sm text-amber-900">{detalheProcesso.motivoPendencia}</span>
                    </div>
                </div>
            )}

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                <div className="col-span-1 md:col-span-2">
                    <Campo label="Fornecedor" valor={detalheProcesso.fornecedorNome } />
                </div>
                 <div className="col-span-1 md:col-span-2 flex items-end gap-3 flex-wrap">
                    <div className="min-w-0">
                        <Campo label="CPF/CNPJ" valor={detalheProcesso.fornecedorCnpj} />
                    </div>
                   
                        <UltimosLancamentosFortes
                            documento={detalheProcesso.fornecedorCnpj}
                            fornecedorNome={detalheProcesso.fornecedorNome}
                        />
                   
                </div>
                <div className="col-span-1 md:col-span-4">
                    <Campo label="Descrição" valor={detalheProcesso.descricao} />
                </div>
                <Campo label="Tipo de despesa" valor={TIPO_DESPESA_LABEL[detalheProcesso.tipoDespesa] || detalheProcesso.tipoDespesa} />
                <Campo label="Valor total" valor={formatarMoeda(detalheProcesso.valorTotal)} />
                <Campo label="Vencimento" valor={formatarData(detalheProcesso.vencimento)} />
                <Campo label="Tipo de pagamento" valor={detalheProcesso.tipoPagamento} />
                <Campo label="Código de Lançamento do Fortes" valor={detalheProcesso.codigoLancamentoFortes} />
                {detalheProcesso.pagamentoRealizado != null && (
                    <Campo label="Pagamento realizado" valor={detalheProcesso.pagamentoRealizado ? "Sim" : "Não"} />
                )}
                {detalheProcesso.tipoPagamento === "Transferência" && (
                    <Campo label="Tipo de conta" valor={detalheProcesso.tipoConta} />
                )}
                {detalheProcesso.tipoPagamento === "Transferência" && (
                    <Campo label="Agência" valor={detalheProcesso.agencia + '-' + detalheProcesso.agenciaDigito} />
                )}
                {detalheProcesso.tipoPagamento === "Transferência" && (
                    <Campo label="Conta" valor={detalheProcesso.conta + '-' + detalheProcesso.contaDigito} />
                )}
                {detalheProcesso.tipoPagamento === "PIX" && (
                    <Campo label="Chave PIX" valor={detalheProcesso.chavePix} />
                )}
            </div>

            {detalheProcesso.numerosNotasFiscais?.length > 0 && (
                <div className="mt-4">
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Notas Fiscais</h3>
                    <div className="flex flex-wrap gap-2">
                        {detalheProcesso.numerosNotasFiscais.map((numero, index) => (
                            <span key={index} className="inline-flex items-center rounded-full bg-muted px-3 py-1 text-xs font-medium text-foreground">
                                {numero}
                            </span>
                        ))}
                    </div>
                </div>
            )}

            {detalheProcesso.rateio?.length > 0 && (
                <div className="mt-4">
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Rateio</h3>
                    <RateioOrcamentarioTabela itens={detalheProcesso.rateio} />
                </div>
            )}
        </div>
    );
}
